// extracted by mini-css-extract-plugin
export default {"Video":"YoutubeEmbed_Video__0+Mgt","OverlayImg":"YoutubeEmbed_OverlayImg__P04qb"};